import { ElementShownAnchor } from '@hh.ru/analytics-js';
import { VSpacing, VSpacingContainer, SearchInput } from '@hh.ru/magritte-ui';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import { useUpdateDraftFilter } from 'src/components/Search/Common/Filters/hooks/draft/useUpdateDraftFilter';
import { toggleValueInArray } from 'src/components/Search/Common/Filters/utils/toggleValueInArray';
import SelectorOption from 'src/components/Search/Resume/Filters/Geo/SelectorOption';
import { useGeoFiltersAnalytics } from 'src/components/Search/Resume/Filters/Geo/hooks/useAnalytics';
import { useSearchDistrictState } from 'src/components/Search/Resume/Filters/Geo/hooks/useSearchDistrictState';
import translation from 'src/components/translation';
import { useSelector } from 'src/hooks/useSelector';
import { EMPTY_CLUSTER } from 'src/models/search/common/clusters';
import { ClusterKey } from 'src/types/search/common/clusters';

const TrlKeys = {
    districtTitle: 'search.resume.filters.geo.district.title',
};

const District: TranslatedComponent = ({ trls }) => {
    const applyDraftFilter = useUpdateDraftFilter(ClusterKey.District);

    const districtCluster = useSelector((state) => state.searchDraftClusters[ClusterKey.District]);
    const { selectedValues: selectedAreas } =
        useSelector((state) => state.searchDraftClusters[ClusterKey.Area]) || EMPTY_CLUSTER;
    const selectedAreaId = selectedAreas[0];
    const { query, searchItems, handleQueryChange } = useSearchDistrictState(selectedAreaId);

    const { sendEventShowDistrictFilter } = useGeoFiltersAnalytics();

    return (
        <ElementShownAnchor fn={sendEventShowDistrictFilter}>
            <SearchInput
                value={query}
                onChange={handleQueryChange}
                placeholder={trls[TrlKeys.districtTitle]}
                clearable
            />
            <VSpacing default={16} />
            <VSpacingContainer default={12}>
                {searchItems.map(({ id, name }) => (
                    <SelectorOption
                        key={id}
                        isSelected={!!districtCluster?.selectedValues.includes(Number(id))}
                        onClick={() =>
                            applyDraftFilter(toggleValueInArray(Number(id), districtCluster?.selectedValues || []))
                        }
                        text={name}
                        count={districtCluster?.groups[id]?.count || 0}
                    />
                ))}
            </VSpacingContainer>
        </ElementShownAnchor>
    );
};

export default translation(District);
